module.exports = __webpack_public_path__ + "img/agreementBg.f6ba8400.png";